import Vue from 'vue';
import { mapGetters } from 'vuex';
import NarrowFormContainer from 'src/components/account/NarrowFormContainer.vue';
import { UPDATE_USER } from 'src/store/types';
import { Auth0 } from 'src/plugins/auth0';
import { BfSpinner } from "components/Butterfly";
import auth from 'src/api/auth';
import { Form, Field } from 'components/forms';
import 'components/forms/rules/required';
export default Vue.extend({
    components: { NarrowFormContainer, BfSpinner, Form, Field },
    data() {
        return {
            loading: true,
            loadingFailure: false,
            success: undefined,
            auth0: true,
            auth0Success: undefined,
            auth0Message: '',
            user: {},
        };
    },
    computed: {
        ...mapGetters([
            'currentSite', 'currentUser', 'featureFlags',
        ]),
        initialFormValues() {
            return {
                first_name: this.currentUser?.first_name ?? '',
                last_name: this.currentUser?.last_name ?? '',
            };
        },
    },
    metaInfo() {
        return {
            title: this.currentSite ? `${this.currentSite.site_name} Profile - Kapiche` : null
        };
    },
    async mounted() {
        await this.loadUserProfile();
    },
    methods: {
        async loadUserProfile() {
            this.loadingFailure = false;
            this.loading = true;
            try {
                this.user = await auth.getUserProfile();
            }
            catch (e) {
                this.loadingFailure = true;
            }
            finally {
                this.loading = false;
            }
        },
        async auth0ChangePassword() {
            try {
                const res = await Auth0.requestPasswordChange(this.user.email);
                if (res.status === 200) {
                    this.auth0Success = true;
                    this.auth0Message = 'Please check your email inbox.';
                }
                else {
                    throw null;
                }
            }
            catch (e) {
                this.auth0Success = false;
                this.auth0Message = 'Something went wrong, please refresh and try again.';
                if (e)
                    throw e;
            }
        },
        async updateUser({ first_name, last_name }) {
            try {
                this.success = undefined;
                await this.$store.dispatch({
                    type: UPDATE_USER,
                    first_name,
                    last_name,
                });
                this.success = true;
                setTimeout(() => { this.success = undefined; }, 2500);
            }
            catch {
                this.success = false;
                setTimeout(() => { this.success = undefined; }, 2500);
            }
        }
    }
});
